var _rect, _rect2, _rect3, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFloatBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 60,
    height: 60,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "#004899"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    transform: "translate(8 8)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 31.375V26.875H24V31.375H48Z",
    fill: "#E53323"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 40.375V35.875H24V40.375H48Z",
    fill: "#E53323"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48 22.375V17.875H24V22.375H48Z",
    fill: "#E53323"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.156 54.776H32.712V53.36H27.156V54.776ZM32.712 50.6H27.156V52.016H32.712V50.6ZM32.712 47.876H27.156V49.256H32.712V47.876ZM25.716 46.484H34.224V56.912H32.712V56.168H27.156V56.912H25.716V46.484ZM42.696 51.524V51.776C42.948 52.244 43.248 52.688 43.62 53.096C44.256 52.628 44.988 52.028 45.468 51.524H42.696ZM45.552 51.524L46.728 52.376C46.044 52.94 45.228 53.504 44.544 53.948C45.348 54.572 46.332 55.052 47.448 55.34C47.124 55.64 46.704 56.228 46.488 56.6C44.916 56.084 43.656 55.184 42.696 53.984V55.7C42.696 56.384 42.54 56.696 42.048 56.888C41.568 57.068 40.908 57.092 40.008 57.092C39.924 56.708 39.708 56.204 39.528 55.856C40.092 55.892 40.788 55.892 40.968 55.88C41.16 55.88 41.232 55.832 41.232 55.664V54.776C39.9 55.352 38.532 55.94 37.44 56.396L36.66 55.112C37.788 54.728 39.552 54.068 41.232 53.408V51.524H36.768V50.288H44.316L44.352 49.64H37.884V48.368H44.424L44.448 47.72H37.488V46.424H44.64L44.904 46.364L46.056 46.424C46.032 47.672 45.948 49.052 45.828 50.288H47.292V51.524H45.552ZM40.596 53.024L39.576 53.996C39.144 53.528 38.184 52.88 37.428 52.448L38.376 51.584C39.108 51.968 40.104 52.556 40.596 53.024Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloatBtn);
export default __webpack_public_path__ + "static/media/float-btn.56b456fb2b6396e75532f247efcad619.svg";
export { ForwardRef as ReactComponent };